import { render, staticRenderFns } from "./pricing-bulk-form.vue?vue&type=template&id=0a02a440"
import script from "./pricing-bulk-form.vue?vue&type=script&lang=js"
export * from "./pricing-bulk-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports